import React, { useState, memo } from "react";
import ShopifyModal from "../ShopifyModal";
import { Toast } from '@shopify/polaris';
const OrderNoteModal = memo(
  ({
    paymentData,
    handlePaymentButtonClose,
    handleWalletActive,
  }) => {
    const [showToast, setShowToast] = useState(false);
    const [showToastText, setShowToastText] = useState("");
    const [showToastIserror, setShowToastIserror] = useState(false);

    //提示弹窗
    const toggleToast = (showToastText, showToastIserror = false) => {
      setShowToast(showToastText !== "");
      setShowToastText(showToastText);
      setShowToastIserror(showToastIserror);
    };
    const toastMarkup = showToast ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast("")}
        error={showToastIserror}
      />
    ) : null;
    return (
      <div style={{ margin: "0 0" }}>
        {toastMarkup}
        <ShopifyModal id="shared-wallet-for-order-modal"
          open={paymentData.isWalletModal}
          onClose={() => handlePaymentButtonClose(paymentData)}
          heading={"Order: " + paymentData.orderName}
          primaryAction={{
            content: "Yes",
            onAction: () => handleWalletActive(),
            loading: paymentData.toWalletButtonLoading,
          }}
          loading={paymentData.toCheckoutLoading}
        >
          <p>
              {"Current credit balance"}{" "}
              {"$" + parseFloat(paymentData.walletMoney) + " USD"},{" "}
              {"order total price"}{" "}
              {"$" +
                (
                  parseFloat(paymentData.paymentMoney)).toFixed(2) +
                " USD"}
              . {"Are you sure to pay by credit balance?"}
            </p>
          </ShopifyModal>
      </div>
    );
  }
);

export default OrderNoteModal;
